import React, { useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from '@mui/material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Navigation from '../../Components/Navigation/navigation';
import ProjectSelector from '../../Components/ProjectSelector/projectSelector';
import SimulationBanner from '../../Components/SimulationBanner/SimulationBanner';
import DataContext from '../../Contexts/DataContext';
import { Copyright } from '../../Helpers/utils';

const mdTheme = createTheme();

function Dashboard(props) {
  const history = useHistory();

  return (
    <ThemeProvider theme={mdTheme}>
      <Box 
        sx={{ 
          display: 'flex'
        }}
      >
        <Navigation title={'Dashboard'} />
        <Box
          component='main'
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Container 
            maxWidth='lg'
            sx={{
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              height: 'calc(100% - 128px)',
              mb: 4,
              mt: 4,
            }}
          >
            <SimulationBanner />

            <Grid 
              container 
              spacing={3}
            >
              <Grid 
                item 
                xs={12}
              >
                <ProjectSelector />
              </Grid>
            </Grid>
            <Copyright 
              sx={{
                alignSelf: 'flex-end',
                pt: 4,
              }}
            />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default Dashboard;
